import React from 'react';
import { Container } from 'react-bootstrap';
import './styles.scss';
import { Link, useParams } from 'react-router-dom';
import HiringBoardCard from 'components/Common/Company/HiringBoardCard';
import { useJobDetailsQuery } from 'services';
import useTranslate from 'hooks/useTranslate';

const HiringBoard: React.FC = () => {
	const { translate } = useTranslate();
	const { id } = useParams();
	const { data } = useJobDetailsQuery(id);

	return (
		<section className="hiring-board py-50 bg-white">
			<Container fluid>
				<div className="mb-3">
					<Link to="/company/my-jobs" className="back-link">
						<i className="ri-arrow-left-line"></i> {translate('HiringBoard.backToList')}
					</Link>
				</div>
				<div className="hiring-board-heading">
					<h3 className="fw-bold mb-0">{translate('HiringBoard.hiringBoard')}</h3>
					<h2 className="fw-semibold mb-0">{data?.title}</h2>
				</div>
				<div className="hiring-board-content">
					<div className="hiring-board-lists d-flex flex-wrap">
						<HiringBoardCard
							jobStatus="applied"
							title={translate('Button.applied')}
							titleColor=""
						/>
						<HiringBoardCard
							jobStatus="screened"
							title={translate('Button.shortlisted')}
							titleColor="bg-yellow"
						/>
						<HiringBoardCard
							jobStatus="interview"
							title={translate('Button.interviewed')}
							titleColor="bg-skyblue"
						/>
						<HiringBoardCard
							jobStatus="offered"
							title={translate('Button.offered')}
							titleColor="bg-purple"
						/>
					</div>
				</div>
			</Container>
		</section>
	);
};

export default HiringBoard;
